module.exports = __webpack_public_path__ + "media/globe_loop.ddd6da4b.mp4";